import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {sx} from './sx';

interface IProps {
    open: boolean,
    onCancel: () => void,
    onStart: () => void,
}

// Asked every time the air defence game is switched on: it is political satire, and nobody gets
// it without agreeing to that first.
const DefenceDisclaimer = ({open, onCancel, onStart}: IProps) => {

    const {t} = useTranslation()

    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby={'defence-disclaimer-title'}
            PaperProps={{sx: sx.dialogPaper}}
        >
            <DialogTitle id={'defence-disclaimer-title'} sx={sx.dialogTitle}>
                {t('auth.disclaimerTitle')}
            </DialogTitle>
            <DialogContent>
                <Typography sx={sx.dialogText}>{t('auth.disclaimerText')}</Typography>
                <Typography sx={{...sx.dialogText, mt: 1.5}}>{t('auth.disclaimerQuestion')}</Typography>
            </DialogContent>
            <DialogActions sx={sx.dialogActions}>
                <Button onClick={onCancel} variant={'outlined'} sx={sx.demo}>
                    {t('auth.disclaimerCancel')}
                </Button>
                <Button onClick={onStart} variant={'contained'} sx={sx.submit} autoFocus>
                    {t('auth.disclaimerStart')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DefenceDisclaimer;
